/* eslint-disable import/no-anonymous-default-export */
export default {
  "field.name": "Nombre",
  "field.description": "Descripción",
  "field.status": "Estado",
  "field.created_at": "Creado en",
  "field.created_by": "Creado por",
  "field.updated_at": "Actualizado en",
  "field.updated_by": "Actualizado por",
  "field.revision": "Revisión",
  "field.active.true": "Activo",
  "field.active.false": "Inactivo",
  "field.search": "Buscar",
};
